var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "assets"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Assets")]), _c('v-alert', {
    staticClass: "testnet_alert",
    attrs: {
      "text": "",
      "type": "info",
      "rounded": "0"
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(" Notice: This explorer only indexes the X-Chain and P-Chain. To view C-Chain transactions (EVM chain), click "), _c('a', {
    staticClass: "bold c_chain_link",
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("here")]), _vm._v(". ")])]), _vm.assetsLoaded ? [_c('div', {
    staticClass: "bar"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm._f("pluralize")(Object.keys(_vm.assets).length, 'asset')) + " found ")])]), _vm._m(0)] : _vm._e()], 2), !_vm.assetsLoaded ? _c('div', [_c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _vm.assetsLoaded && _vm.$vuetify.breakpoint.xsOnly ? _c('div', {
    staticClass: "asset_list"
  }, [_c('div', {
    staticClass: "grid_headers asset_row"
  }, [_c('p', [_vm._v(" Symbol "), _c('Tooltip', {
    attrs: {
      "content": "An arrangement of letters representing an asset"
    }
  })], 1), _c('p', [_vm._v(" Name "), _c('Tooltip', {
    attrs: {
      "content": "Name for the asset"
    }
  })], 1)]), _vm._l(_vm.assets, function (asset) {
    return _c('AssetRow', {
      key: asset.id,
      staticClass: "asset_row",
      attrs: {
        "asset": asset
      }
    });
  })], 2) : _vm._e(), _vm.$vuetify.breakpoint.smAndUp ? _c('div', [_c('AssetsDataTable', {
    attrs: {
      "assets": _vm.assets
    }
  })], 1) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bar"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(" Assets are updated on 5-min intervals. Please refresh to view new listings. ")])]);
}]

export { render, staticRenderFns }